import React from "react";
import yn from "yn";
import { StytchProvider as Provider } from "@stytch/react";
import { StytchHeadlessClient } from "@stytch/vanilla-js/headless";
import memoize from "@RHCommerceDev/utils/memoize";
import { getGlobal } from "@RHCommerceDev/utils/Globals/getGlobal";

const env = getGlobal("_env");

const stytchOptions = {
  cookieOptions: {
    path: "/",
    availableToSubdomains: true,
    domain: `.${env.ENV_DOMAIN}`
  }
}

const STYTCH_TOKEN = yn(env?.FEATURE_STYTCH_TEST)
  ? env?.STYTCH_TEST_PUBLIC_TOKEN
  : env?.STYTCH_PUBLIC_TOKEN;

const stytchClient = new StytchHeadlessClient(STYTCH_TOKEN, stytchOptions);

const StytchProvider = ({ children }) => {
  return <Provider stytch={stytchClient}>{children}</Provider>;
};

export default memoize(StytchProvider);
